import store from '@/store';
import base from '@/__vue2stone/service/wasaapi/v1/__base';
import S_questionType from '@/service/api/v1/questionType';

export default {
  async index(params) {
    const res = await base.index({
      modelName: 'answer_setting',
      pagination: true,
      params,
    });
    return res;
  },
  async getQuesType(typeValue) {
    await S_questionType.updateQuesTypeListInVuex();
    const quesTypeList = store.state.model.quesTypeList;
    const tarQuesType = quesTypeList.find(type => type.value === typeValue);
    return tarQuesType;
  },
  async getNumConditionTypeList() {
    const quesTypeNum = await this.getQuesType('num');
    const {data} = await this.index({question_type: quesTypeNum.id});
    return data;
  },
  async getTempOptionList() {
    const quesTypeNum = await this.getQuesType('single-choice');
    const {data} = await this.index({question_type: quesTypeNum.id});
    return data;
  },
  async updateNumConditionTypeListInVuex() {
    const numConditionTypeList = store.state.model.numConditionTypeList;
    if (!numConditionTypeList || !numConditionTypeList.length) {
      const newNumConditionTypeList = await this.getNumConditionTypeList();
      store.dispatch('model/setNumConditionTypeList', newNumConditionTypeList);
    }
  }
}